(function () {
  "use strict";

  var e = {
    238: function _(e) {
      e.exports = require("@yaswap/crypto");
    },
    674: function _(e) {
      e.exports = require("@yaswap/errors");
    },
    64: function _(e) {
      e.exports = require("@yaswap/types");
    },
    685: function _(e) {
      e.exports = require("setimmediate");
    }
  },
      r = {};

  function t(a) {
    var i = r[a];
    if (void 0 !== i) return i.exports;
    var n = r[a] = {
      exports: {}
    };
    return e[a](n, n.exports, t), n.exports;
  }

  var a = {};
  (function () {
    var e = a;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.validateExpiration = e.validateSecretAndHash = e.validateSecretHash = e.validateSecret = e.validateValue = e.caseInsensitiveEqual = e.asyncSetImmediate = e.addressToString = e.sleep = void 0, t(685);
    var r = t(674),
        i = t(238),
        n = t(64);

    function o(e) {
      if ("string" != typeof e) throw new r.InvalidSecretError("Invalid secret hash type");
      if (Buffer.from(e, "hex").toString("hex") !== e) throw new r.InvalidSecretError("Invalid secret hash. Not Hex.");
      if (32 !== Buffer.byteLength(e, "hex")) throw new r.InvalidSecretError("Invalid secret hash: ".concat(e));
      if ((0, i.sha256)("0000000000000000000000000000000000000000000000000000000000000000") === e) throw new r.InvalidSecretError("Invalid secret hash: ".concat(e, ". Secret 0 detected."));
    }

    function s(e) {
      if ("string" != typeof e) throw new r.InvalidSecretError("Invalid secret type");
      if (Buffer.from(e, "hex").toString("hex") !== e) throw new r.InvalidSecretError("Invalid secret. Not Hex.");
      if (32 !== Buffer.from(e, "hex").length) throw new r.InvalidSecretError("Invalid secret size");
    }

    e.addressToString = function (e) {
      return "string" == typeof e ? e : e.address;
    }, e.sleep = function (e) {
      return new Promise(function (r) {
        return setTimeout(r, e);
      });
    }, e.asyncSetImmediate = function () {
      return new Promise(function (e) {
        return setImmediate(e);
      });
    }, e.caseInsensitiveEqual = function (e, r) {
      return (e = e && e.toLowerCase()) === (r && r.toLowerCase());
    }, e.validateValue = function (e) {
      if (!n.BigNumber.isBigNumber(e)) throw new Error("Invalid value: ".concat(e));
      if (e.lte(0)) throw new Error("Invalid value: ".concat(e));
    }, e.validateSecretHash = o, e.validateSecret = s, e.validateSecretAndHash = function (e, t) {
      if (s(e), o(t), !Buffer.from((0, i.sha256)(e), "hex").equals(Buffer.from(t, "hex"))) throw new r.InvalidSecretError("Invalid secret: Does not match expected secret hash: ".concat(t));
    }, e.validateExpiration = function (e) {
      if (isNaN(e)) throw new r.InvalidExpirationError("Invalid expiration. NaN: ".concat(e));
      if (e < 5e8 || e > 5e12) throw new r.InvalidExpirationError("Invalid expiration. Out of bounds: ".concat(e));
    };
  })(), module.exports = a;
})();